(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-service/assets/javascripts/get-banner-type.js') >= 0) return;  svs.modules.push('/components/content/banner-service/assets/javascripts/get-banner-type.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  var layouts = {
    background: 'background',
    column: 'column',
    quickplay: 'quickplay',
    slimBanner: 'slimBanner'
  };

  function getBannerType(banner) {
    var hasImageOrVideo = banner.images && banner.images[100] || banner.video;
    var hasBackgroundImage = banner.images && banner.images[200];

    var hasBagType = function hasBagType(bagType) {
      return banner.bagType && banner.bagType.indexOf(bagType) > -1;
    };

    if (hasBagType('rubbet') && hasBackgroundImage) {
      return {
        name: 'rubbet',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_bag-banner_rubbet',
        path: 'tur/banner-type-bag'
      };
    }

    if (hasBagType('lordagsgodis') && hasBackgroundImage) {
      return {
        name: 'lordagsgodis',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_bag-banner_lordagsgodis',
        path: 'tur/banner-type-bag'
      };
    }

    if (hasBagType('xperten') && hasBackgroundImage) {
      return {
        name: 'xperten',
        partialLayout: layouts.background,
        partialName: 'components-sport-banner_type_xperten-banner_xperten',
        path: 'sport/banner-type-xperten'
      };
    }

    if (banner.subtype === 'trissDirectPlay' && hasBackgroundImage) {
      return {
        name: 'trissDirectPlay',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_trissdirectplay-banner_trissdirectplay',
        path: 'tur/banner-type-trissdirectplay'
      };
    }

    if (banner.oddsetMatchId && hasBackgroundImage) {
      return {
        name: 'oddset-playable',
        partialLayout: layouts.background,
        partialName: 'components-sport-banner_type_oddset_playable-banner_oddset_playable',
        path: 'sport/banner-type-oddset-playable'
      };
    }

    if (banner.formLinkForm && (hasImageOrVideo || hasBackgroundImage)) {
      return {
        name: 'form',
        partialLayout: hasBackgroundImage ? layouts.background : layouts.column,
        partialName: 'components-content-banner_type_form-banner_form',
        path: 'content/banner-type-form'
      };
    }

    if (banner.subtype === 'slimBanner') {
      return {
        name: 'slimBanner',
        partialLayout: layouts.slimBanner,
        partialName: 'components-content-banner_type_slimbanner-banner_slimbanner',
        path: 'content/banner-type-slimbanner'
      };
    }

    if (banner.subtype === 'layersBanner') {
      return {
        name: 'layers',
        partialLayout: layouts.background,
        partialName: 'components-content-banner_type_layer-banner_layer',
        path: 'content/banner-type-layer'
      };
    }

    if (banner.c2a && hasBackgroundImage) {
      return {
        name: 'background',
        partialLayout: layouts.background,
        partialName: 'components-content-banner_type_background-banner_background',
        path: 'content/banner-type-background'
      };
    }

    if (banner.c2a && hasImageOrVideo) {
      return {
        name: 'column',
        partialLayout: layouts.column,
        partialName: 'components-content-banner_type_column-banner_column',
        path: 'content/banner-type-column'
      };
    }

    if (banner.quickPlayProductId) {
      return {
        name: 'quickplay',
        partialLayout: layouts.quickplay,
        partialName: 'components-content-banner_type_quickplay-banner_quickplay',
        path: 'content/banner-type-quickplay'
      };
    }

    throw new Error('Unrecognized banner type');
  }

  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
    module.exports = getBannerType;
  } else {
    svs.content.bannerService.getBannerType = getBannerType;
  }
})();
 })(window);